import { FormControl, FormHelperText, TextField, TextFieldProps } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type SGSInputProps = TextFieldProps & {
    name: string;
    label: string;
    id?: string;
    helperText?: string;
};

const SGSInputIncrement: React.FC<SGSInputProps> = ({ id, name, label, helperText, ...props }) => {
    const { t } = useTranslation();

    const {
        control,
        formState: { errors },
    } = useFormContext();

    const errorPath = name.split('.');
    const hasError = errorPath.reduce((obj, key) => obj && obj[key], errors);

    return (
        <FormControl variant={props.variant} error={hasError ? true : false}>
            <Controller
                name={name}
                control={control}
                defaultValue={0}
                render={({ field: { onChange, value } }) => (
                    <Box>
                        <TextField
                            {...props}
                            label={t(label)}
                            variant="outlined"
                            type="text"
                            value={value}
                            onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)}
                            fullWidth
                            inputProps={{ style: { textAlign: 'center' } }}
                        />
                        <Box textAlign="right" style={{ marginTop: '-50px', marginRight: '10px' }}>
                            <IconButton aria-label="decrease" onClick={() => onChange(parseInt(value) > 0 ? parseInt(value) - 1 : 0)} disabled={value <= 0}>
                                <RemoveIcon />
                            </IconButton>
                            <IconButton aria-label="increase" onClick={() => onChange(parseInt(value) + 1)}>
                                <AddIcon />
                            </IconButton>
                        </Box>
                    </Box>
                )}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
            {errors[name] && <FormHelperText error>{errors[name].message}</FormHelperText>}
        </FormControl>
    );
};

export default SGSInputIncrement;
